export default __webpack_public_path__ + "static/media/404-error-3702359-3119148.098d5b4e.webp";